/**
 * NBN Brauz Replacement Widget — v1 Style
 * Clean card layout with inline stock, pink Check button, shipping table
 */

(function() {
  // Stock is fetched via our carrier service (proxies Admin API with correct per-location data)
  const STOCK_ENDPOINT = 'https://carrier.naughtybutnice.au/stock';
  const DELIVERY_POSTCODE_STORAGE_KEY = 'nbn_delivery_postcode';
  const DELIVERY_POSTCODE_ACTUAL_STORAGE_KEY = 'nbn_delivery_postcode_actual';

  const STORES = {
    '63541706925': {
      name: 'Cannon Hill',
      address: '19/1177 Wynnum Road, Cannon Hill QLD 4170',
      phone: '(07) 3890 0662',
      lat: -27.4698, lng: 153.0851,
      hours: [
        ['Monday',    '9:30am – 7:00pm'],
        ['Tuesday',   '9:30am – 7:00pm'],
        ['Wednesday', '9:30am – 9:00pm'],
        ['Thursday',  '9:30am – 9:00pm'],
        ['Friday',    '9:30am – 9:00pm'],
        ['Saturday',  '9:30am – 9:00pm'],
        ['Sunday',    '10:00am – 6:00pm'],
      ],
      hoursNote: 'Open public holidays 10am – 6pm excl. Christmas Day, Good Friday & ANZAC Day 1pm – 6pm'
    },
    '71767556269': {
      name: 'Capalaba',
      address: '2/150 Redland Bay Road, Capalaba QLD 4157',
      phone: '(07) 3390 1100',
      lat: -27.5167, lng: 153.1833,
      hours: [
        ['Monday',    '9:30am – 7:00pm'],
        ['Tuesday',   '9:30am – 7:00pm'],
        ['Wednesday', '9:30am – 9:00pm'],
        ['Thursday',  '9:30am – 9:00pm'],
        ['Friday',    '9:30am – 9:00pm'],
        ['Saturday',  '9:30am – 9:00pm'],
        ['Sunday',    '10:00am – 6:00pm'],
      ],
      hoursNote: 'Open public holidays 10am – 6pm excl. Christmas Day, Good Friday & ANZAC Day 1pm – 6pm'
    },
    '79725527213': {
      name: 'Margate',
      address: '4/300 Oxley Avenue, Margate QLD 4019',
      phone: '0497 313 274',
      lat: -27.0333, lng: 153.0833,
      hours: [
        ['Monday',    '9:30am – 7:00pm'],
        ['Tuesday',   '9:30am – 7:00pm'],
        ['Wednesday', '9:30am – 9:00pm'],
        ['Thursday',  '9:30am – 9:00pm'],
        ['Friday',    '9:30am – 9:00pm'],
        ['Saturday',  '9:30am – 9:00pm'],
        ['Sunday',    '10:00am – 6:00pm'],
      ],
      hoursNote: 'Open public holidays 10am – 6pm excl. Christmas Day, Good Friday & ANZAC Day 1pm – 6pm'
    },
    '95572263085': {
      name: 'Stafford',
      address: 'Shop 5, 259 Stafford Rd, Stafford QLD 4053',
      phone: '1300 639 837',
      lat: -27.4107431, lng: 153.0206218,
      hours: [
        ['Monday',    '9:30am – 7:00pm'],
        ['Tuesday',   '9:30am – 7:00pm'],
        ['Wednesday', '9:30am – 9:00pm'],
        ['Thursday',  '9:30am – 9:00pm'],
        ['Friday',    '9:30am – 9:00pm'],
        ['Saturday',  '9:30am – 9:00pm'],
        ['Sunday',    '10:00am – 6:00pm'],
      ],
      hoursNote: 'Open public holidays 10am – 6pm excl. Christmas Day, Good Friday & ANZAC Day 1pm – 6pm'
    },
    '86314156205': {
      name: 'Gold Coast Warehouse',
      address: '5/645 Pine Ridge Road, Biggera Waters QLD 4216',
      phone: '(07) 3390 1100',
      lat: -27.92546, lng: 153.37719,
      supportsPickup: false,
      deliveryLabel: 'Same-Day Delivery',
      hours: [
        ['Monday',    'Order by 1pm for delivery by 5pm'],
        ['Tuesday',   'Order by 1pm for delivery by 5pm'],
        ['Wednesday', 'Order by 1pm for delivery by 5pm'],
        ['Thursday',  'Order by 1pm for delivery by 5pm'],
        ['Friday',    'Order by 1pm for delivery by 5pm'],
        ['Saturday',  'Closed'],
        ['Sunday',    'Closed'],
      ],
      hoursNote: 'Gold Coast Same-Day Delivery: Monday-Friday only. Order by 1pm for delivery by 5pm. Weekend/public holiday delivery orders process next business day.'
    },
    '86338404525': {
      name: 'Sydney Warehouse',
      address: '1A/35 Stennett Road, Ingleburn NSW 2565',
      phone: '(07) 3390 1100',
      lat: -34.00185, lng: 150.85301,
      supportsPickup: true,
      supportsReserve: false,
      deliveryLabel: '3-Hour Delivery',
      hours: [
        ['Monday',    'Click & Collect + 3-hour delivery'],
        ['Tuesday',   'Click & Collect + 3-hour delivery'],
        ['Wednesday', 'Click & Collect + 3-hour delivery'],
        ['Thursday',  'Click & Collect + 3-hour delivery'],
        ['Friday',    'Click & Collect + 3-hour delivery'],
        ['Saturday',  'Closed'],
        ['Sunday',    'Closed'],
      ],
      hoursNote: 'Sydney Click & Collect: order before 12pm for same day pickup. Otherwise ready next business day. Sydney 3-Hour Delivery: Monday-Friday only. Order by 11am for delivery by 2pm, or order by 2pm for delivery by 5pm. Weekend/public holiday delivery orders process next business day.'
    }
  };

  const PINK = '#ED037C';
  const CHARCOAL = '#171717';

  // Suburb name → postcode lookup (minimal fallback for offline/error cases)
  const SUBURB_MAP = [
    {suburb:'Brisbane CBD',pc:4000},{suburb:'Brisbane City',pc:4000},{suburb:'Spring Hill',pc:4000},
    {suburb:'Fortitude Valley',pc:4006},{suburb:'New Farm',pc:4005},{suburb:'Teneriffe',pc:4005},
    {suburb:'Newstead',pc:4006},{suburb:'Bowen Hills',pc:4006},{suburb:'Herston',pc:4006},
    {suburb:'Windsor',pc:4030},{suburb:'Kedron',pc:4031},{suburb:'Gordon Park',pc:4031},
    {suburb:'Chermside',pc:4032},{suburb:'Wavell Heights',pc:4012},{suburb:'Nundah',pc:4012},
    {suburb:'Toombul',pc:4012},{suburb:'Clayfield',pc:4011},{suburb:'Wooloowin',pc:4011},
    {suburb:'Albion',pc:4010},{suburb:'Kalinga',pc:4030},{suburb:'Lutwyche',pc:4030},
    {suburb:'Hamilton',pc:4007},{suburb:'Ascot',pc:4007},{suburb:'Eagle Farm',pc:4009},
    {suburb:'Pinkenba',pc:4008},{suburb:'Hendra',pc:4011},{suburb:'Banyo',pc:4014},
    {suburb:'Virginia',pc:4014},{suburb:'Nudgee',pc:4014},{suburb:'Northgate',pc:4013},
    {suburb:'Geebung',pc:4034},{suburb:'Zillmere',pc:4034},{suburb:'Aspley',pc:4034},
    {suburb:'Carseldine',pc:4034},{suburb:'Bald Hills',pc:4036},{suburb:'Bracken Ridge',pc:4017},
    {suburb:'Sandgate',pc:4017},{suburb:'Brighton',pc:4017},{suburb:'Deagon',pc:4017},
    {suburb:'Shorncliffe',pc:4017},{suburb:'Clontarf',pc:4019},{suburb:'Margate',pc:4019},
    {suburb:'Redcliffe',pc:4020},{suburb:'Scarborough',pc:4020},{suburb:'Newport',pc:4020},
    {suburb:'Kippa-Ring',pc:4021},{suburb:'Mango Hill',pc:4509},{suburb:'North Lakes',pc:4509},
    {suburb:'Petrie',pc:4502},{suburb:'Kallangur',pc:4503},{suburb:'Dakabin',pc:4503},
    {suburb:'Lawnton',pc:4501},{suburb:'Strathpine',pc:4500},{suburb:'Brendale',pc:4500},
    {suburb:'Stafford',pc:4053},{suburb:'Stafford Heights',pc:4053},{suburb:'Everton Park',pc:4053},
    {suburb:'Mitchelton',pc:4053},{suburb:'Gaythorne',pc:4051},{suburb:'Alderley',pc:4051},
    {suburb:'Keperra',pc:4054},{suburb:'Ferny Grove',pc:4055},{suburb:'Ferny Hills',pc:4055},
    {suburb:'Arana Hills',pc:4054},{suburb:'Enoggera',pc:4051},{suburb:'Ashgrove',pc:4060},
    {suburb:'The Gap',pc:4061},{suburb:'Bardon',pc:4065},{suburb:'Paddington',pc:4064},
    {suburb:'Red Hill',pc:4059},{suburb:'Kelvin Grove',pc:4059},{suburb:'Newmarket',pc:4051},
    {suburb:'Wilston',pc:4051},{suburb:'Grange',pc:4051},{suburb:'Lutwyche',pc:4030},
    {suburb:'Indooroopilly',pc:4068},{suburb:'Taringa',pc:4068},{suburb:'Toowong',pc:4066},
    {suburb:'Auchenflower',pc:4066},{suburb:'Milton',pc:4064},{suburb:'West End',pc:4101},
    {suburb:'South Brisbane',pc:4101},{suburb:'Highgate Hill',pc:4101},{suburb:'Dutton Park',pc:4102},
    {suburb:'Woolloongabba',pc:4102},{suburb:'East Brisbane',pc:4169},{suburb:'Kangaroo Point',pc:4169},
    {suburb:'Norman Park',pc:4170},{suburb:'Camp Hill',pc:4152},{suburb:'Coorparoo',pc:4151},
    {suburb:'Greenslopes',pc:4120},{suburb:'Holland Park',pc:4121},{suburb:'Mount Gravatt',pc:4122},
    {suburb:'Upper Mount Gravatt',pc:4122},{suburb:'Eight Mile Plains',pc:4113},{suburb:'Rochedale',pc:4123},
    {suburb:'Underwood',pc:4119},{suburb:'Springwood',pc:4127},{suburb:'Daisy Hill',pc:4127},
    {suburb:'Slacks Creek',pc:4127},{suburb:'Loganholme',pc:4129},{suburb:'Meadowbrook',pc:4131},
    {suburb:'Logan Central',pc:4114},{suburb:'Woodridge',pc:4114},{suburb:'Kingston',pc:4114},
    {suburb:'Beenleigh',pc:4207},{suburb:'Eagleby',pc:4207},{suburb:'Wynnum',pc:4178},
    {suburb:'Manly',pc:4179},{suburb:'Manly West',pc:4179},{suburb:'Lota',pc:4179},
    {suburb:'Wynnum West',pc:4178},{suburb:'Cannon Hill',pc:4170},{suburb:'Morningside',pc:4170},
    {suburb:'Murarrie',pc:4172},{suburb:'Hemmant',pc:4174},{suburb:'Tingalpa',pc:4173},
    {suburb:'Carindale',pc:4152},{suburb:'Belmont',pc:4153},{suburb:'Gumdale',pc:4154},
    {suburb:'Ransome',pc:4154},{suburb:'Wakerley',pc:4154},{suburb:'Thornlands',pc:4164},
    {suburb:'Alexandra Hills',pc:4161},{suburb:'Capalaba',pc:4157},{suburb:'Birkdale',pc:4159},
    {suburb:'Wellington Point',pc:4160},{suburb:'Cleveland',pc:4163},{suburb:'Redland Bay',pc:4165},
    {suburb:'Victoria Point',pc:4165},{suburb:'Ormiston',pc:4160},{suburb:'Raby Bay',pc:4163},
    {suburb:'Annerley',pc:4103},{suburb:'Yeronga',pc:4104},{suburb:'Rocklea',pc:4106},
    {suburb:'Salisbury',pc:4107},{suburb:'Moorooka',pc:4105},{suburb:'Yeerongpilly',pc:4105},
    {suburb:'Corinda',pc:4075},{suburb:'Sherwood',pc:4075},{suburb:'Graceville',pc:4075},
    {suburb:'Chelmer',pc:4068},{suburb:'Fig Tree Pocket',pc:4069},{suburb:'Kenmore',pc:4069},
    {suburb:'Pullenvale',pc:4069},{suburb:'Chapel Hill',pc:4069},{suburb:'Brookfield',pc:4069},
    {suburb:'Moggill',pc:4070},{suburb:'Bellbowrie',pc:4070},{suburb:'Riverhills',pc:4074},
    {suburb:'Middle Park',pc:4074},{suburb:'Jindalee',pc:4074},{suburb:'Sinnamon Park',pc:4073},
    {suburb:'Oxley',pc:4075},{suburb:'Darra',pc:4076},{suburb:'Wacol',pc:4076},
    {suburb:'Inala',pc:4077},{suburb:'Forest Lake',pc:4078},{suburb:'Richlands',pc:4077},
    {suburb:'Sunnybank',pc:4109},{suburb:'Sunnybank Hills',pc:4109},{suburb:'Runcorn',pc:4113},
    {suburb:'Calamvale',pc:4116},{suburb:'Parkinson',pc:4115},{suburb:'Algester',pc:4115},
    {suburb:'Robertson',pc:4109},{suburb:'Macgregor',pc:4109},{suburb:'Stretton',pc:4116},
    {suburb:'Drewvale',pc:4116},{suburb:'Acacia Ridge',pc:4110},{suburb:'Coopers Plains',pc:4108},
    {suburb:'Nathan',pc:4111},{suburb:'Tarragindi',pc:4121},{suburb:'Tennyson',pc:4105},
    {suburb:'Fairfield',pc:4103},{suburb:'Graceville',pc:4075},
    {suburb:'Ipswich',pc:4305},{suburb:'Springfield',pc:4300},
    {suburb:'Ingleburn',pc:2565},{suburb:'Minto',pc:2566},{suburb:'Macquarie Fields',pc:2564},
  ];

  // Brisbane metro postcode → lat/lng
  const POSTCODES = {
    4000:{lat:-27.4679,lng:153.0281},4001:{lat:-27.4832,lng:153.0178},
    4005:{lat:-27.4885,lng:153.0068},4006:{lat:-27.4501,lng:153.0436},
    4007:{lat:-27.4567,lng:153.0355},4009:{lat:-27.4601,lng:152.9934},
    4010:{lat:-27.4566,lng:153.0070},4011:{lat:-27.4491,lng:152.9962},
    4034:{lat:-27.4547,lng:153.0800},4051:{lat:-27.4167,lng:153.0000},
    4053:{lat:-27.4046,lng:153.0357},4054:{lat:-27.3956,lng:153.0188},
    4059:{lat:-27.4491,lng:152.9962},4060:{lat:-27.4601,lng:152.9934},
    4061:{lat:-27.4635,lng:153.0004},4064:{lat:-27.4525,lng:153.0270},
    4065:{lat:-27.4867,lng:152.9695},4066:{lat:-27.5109,lng:152.9708},
    4067:{lat:-27.5316,lng:152.9699},4068:{lat:-27.5566,lng:152.9540},
    4069:{lat:-27.5205,lng:153.0598},4070:{lat:-27.5621,lng:153.0654},
    4072:{lat:-27.5773,lng:153.0715},4073:{lat:-27.5857,lng:153.1232},
    4074:{lat:-27.6371,lng:153.1307},4075:{lat:-27.5167,lng:153.1833},
    4076:{lat:-27.5436,lng:153.2176},4077:{lat:-27.5954,lng:152.9723},
    4078:{lat:-27.6201,lng:152.9584},4101:{lat:-27.4764,lng:153.0152},
    4102:{lat:-27.4825,lng:153.0461},4103:{lat:-27.4912,lng:153.0590},
    4104:{lat:-27.5054,lng:153.0247},4105:{lat:-27.5316,lng:153.0699},
    4107:{lat:-27.5621,lng:153.0654},4108:{lat:-27.5773,lng:153.0715},
    4109:{lat:-27.6257,lng:152.7592},4110:{lat:-27.5837,lng:152.8897},
    4111:{lat:-27.5675,lng:152.9406},4112:{lat:-27.5346,lng:152.8680},
    4113:{lat:-27.5773,lng:153.0715},4114:{lat:-27.5857,lng:153.1232},
    4115:{lat:-27.6371,lng:153.1307},4116:{lat:-27.5773,lng:153.0715},
    4117:{lat:-27.5857,lng:153.1232},4118:{lat:-27.5346,lng:152.8680},
    4119:{lat:-27.5773,lng:153.0715},4120:{lat:-27.5205,lng:153.0598},
    4121:{lat:-27.5316,lng:153.0699},4122:{lat:-27.5621,lng:153.0654},
    4123:{lat:-27.5773,lng:153.0715},4124:{lat:-27.6053,lng:153.0801},
    4125:{lat:-27.6371,lng:153.1307},4127:{lat:-27.6371,lng:153.1307},
    4128:{lat:-27.6371,lng:153.1307},4129:{lat:-27.6053,lng:153.0801},
    4130:{lat:-27.5857,lng:153.1232},4131:{lat:-27.5205,lng:153.0598},
    4132:{lat:-27.5621,lng:153.0654},4133:{lat:-27.6371,lng:153.1307},
    4106:{lat:-27.5511,lng:153.0018},
    4126:{lat:-27.6500,lng:153.0833},4127:{lat:-27.6667,lng:153.1167},
    4128:{lat:-27.6583,lng:153.1333},4129:{lat:-27.6417,lng:153.1500},
    4130:{lat:-27.6250,lng:153.1583},4131:{lat:-27.6000,lng:153.1583},
    4132:{lat:-27.5917,lng:153.1417},4133:{lat:-27.6083,lng:153.1167},
    4134:{lat:-27.6750,lng:153.1583},4135:{lat:-27.6917,lng:153.1583},
    4136:{lat:-27.7083,lng:153.1583},4137:{lat:-27.7250,lng:153.1250},
    4138:{lat:-27.6917,lng:153.2000},4139:{lat:-27.7083,lng:153.2167},
    4140:{lat:-27.7250,lng:153.2333},
    4146:{lat:-27.5500,lng:153.1000},4147:{lat:-27.5667,lng:153.0833},4148:{lat:-27.5500,lng:153.0667},4149:{lat:-27.5333,lng:153.0833},4150:{lat:-27.5167,lng:153.0833},
    4151:{lat:-27.5205,lng:153.0598},4152:{lat:-27.5030,lng:153.0997},
    4153:{lat:-27.3682,lng:153.0233},4154:{lat:-27.3439,lng:153.0552},
    4155:{lat:-27.3290,lng:153.0816},4156:{lat:-27.3290,lng:153.0816},
    4157:{lat:-27.5167,lng:153.1833},4158:{lat:-27.5125,lng:153.1955},
    4159:{lat:-27.4989,lng:153.2127},4160:{lat:-27.4833,lng:153.2333},
    4161:{lat:-27.5333,lng:153.2000},4163:{lat:-27.5333,lng:153.2667},
    4164:{lat:-27.5667,lng:153.2333},4165:{lat:-27.6167,lng:153.3000},
    4169:{lat:-27.4825,lng:153.0461},4170:{lat:-27.4698,lng:153.0851},
    4171:{lat:-27.4547,lng:153.0800},4172:{lat:-27.4428,lng:153.1236},
    4173:{lat:-27.4047,lng:153.0863},4174:{lat:-27.4333,lng:153.1000},
    4178:{lat:-27.4428,lng:153.1236},4179:{lat:-27.0333,lng:153.0833},
    4205:{lat:-27.6667,lng:153.1333},4207:{lat:-27.9752,lng:153.4118},
    4209:{lat:-27.8667,lng:153.3333},4210:{lat:-27.9333,lng:153.3667},
    4211:{lat:-27.8667,lng:153.3000},4212:{lat:-27.8667,lng:153.3667},
    4213:{lat:-28.0667,lng:153.4000},4214:{lat:-27.9667,lng:153.4000},
    4215:{lat:-28.0028,lng:153.4286},4216:{lat:-27.92546,lng:153.37719},
    4217:{lat:-27.9667,lng:153.4286},4218:{lat:-28.0333,lng:153.4333},
    4019:{lat:-27.0167,lng:153.0833},4020:{lat:-27.0333,lng:153.0833},
    4017:{lat:-27.3075,lng:153.0542},4018:{lat:-27.3417,lng:153.0401},
    4021:{lat:-27.0500,lng:153.0833},4022:{lat:-27.2114,lng:153.0550},4500:{lat:-26.6841,lng:153.0939},
    4300:{lat:-27.6695,lng:152.8993},4350:{lat:-27.5598,lng:151.9507},
    2565:{lat:-34.00185,lng:150.85301},2566:{lat:-34.0280,lng:150.8500},2564:{lat:-33.9920,lng:150.8900}
  };

  let currentStockData = {};
  let lastSeenVariantId = null;
  let stockReloadSequence = 0;
  const resolvedPostcodeCoords = {};

  function cleanPostcode(value) {
    return String(value || '').replace(/[^0-9]/g, '').slice(0, 4);
  }

  function getSharedPostcode() {
    try { return cleanPostcode(localStorage.getItem(DELIVERY_POSTCODE_STORAGE_KEY)); }
    catch(e) { return ''; }
  }

  function hasActualSharedPostcode() {
    try { return localStorage.getItem(DELIVERY_POSTCODE_ACTUAL_STORAGE_KEY) === '1'; }
    catch(e) { return false; }
  }

  function setSharedPostcode(postcode, source, options = {}) {
    const clean = cleanPostcode(postcode);
    if (clean.length !== 4) return '';
    const previous = getSharedPostcode();
    const actualPostcode = options.actual !== false;
    try {
      localStorage.setItem(DELIVERY_POSTCODE_STORAGE_KEY, clean);
      localStorage.setItem(DELIVERY_POSTCODE_ACTUAL_STORAGE_KEY, actualPostcode ? '1' : '0');
    } catch(e) {}
    if (previous === clean) return clean;
    window.dispatchEvent(new CustomEvent('nbn:postcode-updated', {
      detail: { postcode: clean, source: source || 'product-widget', actualPostcode }
    }));
    return clean;
  }
  function clearSharedPostcode(source) {
    const previous = getSharedPostcode();
    try { localStorage.removeItem(DELIVERY_POSTCODE_STORAGE_KEY); } catch(e) {}
    try { localStorage.removeItem(DELIVERY_POSTCODE_ACTUAL_STORAGE_KEY); } catch(e) {}
    const input = document.getElementById('nbn-pc-input');
    const result = document.getElementById('nbn-pc-result');
    if (input) input.value = '';
    if (result) result.innerHTML = '';
    refreshStoreRows('');
    updatePostcodeButtonState();
    window.dispatchEvent(new CustomEvent('nbn:postcode-cleared', {
      detail: { previous, source: source || 'product-widget' }
    }));
    window.dispatchEvent(new CustomEvent('nbn:postcode-updated', {
      detail: { postcode: '', source: source || 'product-widget' }
    }));
  }

  function localNow(timeZone) {
    return new Date(new Date().toLocaleString('en-US', { timeZone }));
  }

  function ymd(date) {
    return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
  }

  function atTime(date, time) {
    const parts = time.split(':').map(Number);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), parts[0], parts[1], 0);
  }

  function labelTime(time) {
    const parts = time.split(':').map(Number);
    const hour24 = parts[0];
    const minute = parts[1] || 0;
    const suffix = hour24 >= 12 ? 'pm' : 'am';
    const hour = hour24 % 12 || 12;
    return hour + (minute ? ':' + String(minute).padStart(2, '0') : '') + suffix;
  }

  function dayLabel(date, today, timeZone = 'Australia/Brisbane') {
    if (today) return 'today';
    const now = localNow(timeZone);
    const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    if (ymd(date) === ymd(tomorrow)) return 'tomorrow';
    return date.toLocaleDateString('en-AU', { weekday: 'long' });
  }
  function weekdayLabel(date) {
    return date.toLocaleDateString('en-AU', { weekday: 'long' });
  }

  const QLD_PUBLIC_HOLIDAYS = {
    '2026-01-01': true, '2026-01-26': true, '2026-04-03': true, '2026-04-04': true, '2026-04-05': true, '2026-04-06': true,
    '2026-04-25': true, '2026-05-04': true, '2026-08-12': true, '2026-10-05': true, '2026-12-25': true, '2026-12-26': true, '2026-12-28': true
  };
  const NSW_PUBLIC_HOLIDAYS = {
    '2026-01-01': true, '2026-01-26': true, '2026-04-03': true, '2026-04-04': true, '2026-04-05': true, '2026-04-06': true,
    '2026-04-25': true, '2026-06-08': true, '2026-10-05': true, '2026-12-25': true, '2026-12-26': true, '2026-12-28': true
  };

  function isBusinessDay(date, holidays) {
    const dow = date.getDay();
    return dow !== 0 && dow !== 6 && !(holidays && holidays[ymd(date)]);
  }

  function nextExpressDispatchDate(now = localNow('Australia/Brisbane')) {
    for (let i = 0; i < 10; i++) {
      const date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i, 0, 0, 0);
      if (!isBusinessDay(date, QLD_PUBLIC_HOLIDAYS)) continue;
      if (i === 0 && now >= atTime(date, '12:00')) continue;
      return date;
    }
    return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
  }

  function addBusinessDays(date, days) {
    const cursor = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
    let added = 0;
    while (added < days) {
      cursor.setDate(cursor.getDate() + 1);
      if (isBusinessDay(cursor, QLD_PUBLIC_HOLIDAYS) && isBusinessDay(cursor, NSW_PUBLIC_HOLIDAYS)) added++;
    }
    return cursor;
  }

  function destinationStateForPostcode(postcode) {
    const pc = parseInt(postcode, 10);
    if (!pc && pc !== 0) return '';
    if ((pc >= 1000 && pc <= 2599) || (pc >= 2619 && pc <= 2899) || (pc >= 2921 && pc <= 2999)) return 'NSW';
    if ((pc >= 2600 && pc <= 2618) || (pc >= 2900 && pc <= 2920)) return 'ACT';
    if ((pc >= 3000 && pc <= 3999) || (pc >= 8000 && pc <= 8999)) return 'VIC';
    if ((pc >= 4000 && pc <= 4999) || (pc >= 9000 && pc <= 9999)) return 'QLD';
    if ((pc >= 5000 && pc <= 5799) || (pc >= 5800 && pc <= 5999)) return 'SA';
    if ((pc >= 6000 && pc <= 6797) || (pc >= 6800 && pc <= 6999)) return 'WA';
    if ((pc >= 7000 && pc <= 7799) || (pc >= 7800 && pc <= 7999)) return 'TAS';
    if (pc >= 800 && pc <= 999) return 'NT';
    return '';
  }

  function expressTransitBusinessDays(postcode) {
    const state = destinationStateForPostcode(postcode);
    if (state === 'QLD') return 1;
    if (state === 'NSW' || state === 'ACT' || state === 'VIC') return 2;
    return 3;
  }

  function formatExpressEtaDate(date) {
    return date.toLocaleDateString('en-AU', { weekday: 'long', day: 'numeric', month: 'long' });
  }

  function expressPostEta(postcode = getSharedPostcode()) {
    const dispatch = nextExpressDispatchDate();
    const eta = addBusinessDays(dispatch, expressTransitBusinessDays(postcode));
    return {
      date: eta,
      label: 'Express Post ETA ' + formatExpressEtaDate(eta),
      detail: 'Express Post ETA ' + formatExpressEtaDate(eta) + '. Final postage options show at checkout.'
    };
  }

  function nextBrisbaneCutoff(now = localNow('Australia/Brisbane')) {
    const cutoffs = { 0:'17:45', 1:'18:45', 2:'18:45', 3:'20:45', 4:'20:45', 5:'20:45', 6:'20:45' };
    for (let i = 0; i < 8; i++) {
      const date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i, 0, 0, 0);
      const cutoff = QLD_PUBLIC_HOLIDAYS[ymd(date)] ? '17:45' : (cutoffs[date.getDay()] || '18:45');
      const target = atTime(date, cutoff);
      if (now < target) return { target, cutoff, today: i === 0, service: 'Brisbane 2-hour delivery' };
    }
    return null;
  }

  function nextGoldCoastCutoff(now = localNow('Australia/Brisbane')) {
    for (let i = 0; i < 10; i++) {
      const date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i, 0, 0, 0);
      const dow = date.getDay();
      if (dow === 0 || dow === 6 || QLD_PUBLIC_HOLIDAYS[ymd(date)]) continue;
      const target = atTime(date, '13:00');
      if (now < target) return { target, cutoff: '13:00', arrives: '5pm', date, today: i === 0, service: 'Gold Coast same-day delivery' };
    }
    return null;
  }

  function nextSydneyCutoff(now = localNow('Australia/Sydney')) {
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    const todayDow = today.getDay();
    const serviceClosedToday = todayDow === 0 || todayDow === 6 || !!NSW_PUBLIC_HOLIDAYS[ymd(today)];
    for (let i = 0; i < 10; i++) {
      const date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i, 0, 0, 0);
      const dow = date.getDay();
      if (dow === 0 || dow === 6 || NSW_PUBLIC_HOLIDAYS[ymd(date)]) continue;
      const windows = [
        { cutoff:'11:00', arrives:'2pm' },
        { cutoff:'14:00', arrives:'5pm' }
      ];
      for (const window of windows) {
        const target = atTime(date, window.cutoff);
        if (now < target) return { target, cutoff: window.cutoff, arrives: window.arrives, date, today: i === 0, service: 'Sydney 3-hour delivery', serviceClosedToday };
      }
    }
    return null;
  }
  function isSydneySameDayWindow(info) {
    return !!(info && info.today && !info.serviceClosedToday);
  }
  function nextSydneyWindowAfter(info) {
    if (!info || !info.target) return null;
    const now = new Date(info.target.getTime() + 1000);
    for (let i = 0; i < 10; i++) {
      const date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i, 0, 0, 0);
      const dow = date.getDay();
      if (dow === 0 || dow === 6 || NSW_PUBLIC_HOLIDAYS[ymd(date)]) continue;
      const windows = [
        { cutoff:'11:00', arrives:'2pm' },
        { cutoff:'14:00', arrives:'5pm' }
      ];
      for (const window of windows) {
        const target = atTime(date, window.cutoff);
        if (now < target) return { target, cutoff: window.cutoff, arrives: window.arrives, date, today: i === 0 };
      }
    }
    return null;
  }
  function sydneyWindowLine(info) {
    const next = nextSydneyWindowAfter(info);
    if (!next) return 'Next window updates after this cutoff.';
    return 'Next window: order by ' + labelTime(next.cutoff) + ' ' + dayLabel(next.date, next.today, 'Australia/Sydney') + ' -> delivery by ' + next.arrives;
  }

  function deliveryMetaForStore(store) {
    if (!store) return {
      service: 'Local delivery',
      availableTitle: 'Local delivery available!',
      rateLineLabel: 'Local delivery',
      cutoffText: 'Rate confirmed at checkout.',
      detailText: 'Rate confirmed at checkout.'
    };
    if (store.name === 'Sydney Warehouse') {
      const info = nextSydneyCutoff();
      const closedToday = !!(info && info.serviceClosedToday);
      const sameDayWindow = isSydneySameDayWindow(info);
      const infoDay = info ? (closedToday ? weekdayLabel(info.date) : dayLabel(info.date, info.today, 'Australia/Sydney')) : 'the next business day';
      const cutoffText = closedToday
        ? 'Sydney 3-hour delivery is closed today. Next cutoff is ' + labelTime(info.cutoff) + ' ' + infoDay + ' for delivery by ' + info.arrives + '.'
        : (info
          ? 'Order before ' + labelTime(info.cutoff) + ' ' + infoDay + ' for discreet Sydney 3-hour delivery by ' + info.arrives + '.'
          : 'Sydney 3-hour delivery will process on the next business day.');
      const sydneyExtraText = ' ' + sydneyWindowLine(info) + '. Sydney Click & Collect is available too.';
      const sydneyDetailHtml = `
        <ul style="margin:6px 0 0;padding:0;list-style:none;display:grid;gap:3px;font-size:12px;line-height:1.35;color:#4b4b4b;">
          <li><strong style="color:${CHARCOAL};">${closedToday ? 'Next cutoff' : 'Order by'} ${info ? labelTime(info.cutoff) + ' ' + infoDay + ' -> delivery by ' + info.arrives : 'next business day'}</strong></li>
          <li><strong style="color:${CHARCOAL};">${sydneyWindowLine(info)}</strong></li>
          <li><strong style="color:${CHARCOAL};">Click & Collect available.</strong></li>
        </ul>
      `;
      return {
        service: 'Sydney 3-hour delivery',
        availableTitle: closedToday ? 'Sydney 3-hour delivery is closed today.' : (sameDayWindow ? 'Sydney 3-hour delivery available!' : 'Next Sydney 3-hour delivery window.'),
        rateLineLabel: 'Sydney 3-hour delivery',
        cutoffText: cutoffText + sydneyExtraText,
        detailText: cutoffText + sydneyExtraText + ' Click & Collect orders before 12pm are usually ready same business day.',
        detailHtml: sydneyDetailHtml
      };
    }
    if (store.name === 'Gold Coast Warehouse') {
      const info = nextGoldCoastCutoff();
      const cutoffText = info
        ? 'Order before 1pm ' + dayLabel(info.date, info.today, 'Australia/Brisbane') + ' for discreet Gold Coast same-day delivery by 5pm.'
        : 'Gold Coast same-day delivery will process on the next business day.';
      return {
        service: 'Gold Coast same-day delivery',
        availableTitle: 'Gold Coast same-day delivery available!',
        rateLineLabel: 'Gold Coast same-day delivery',
        cutoffText,
        detailText: cutoffText
      };
    }
    const info = nextBrisbaneCutoff();
    const cutoffText = info && info.today
      ? 'Order before ' + labelTime(info.cutoff) + ' for discreet 2-hour delivery from your nearest Brisbane store.'
      : 'Brisbane 2-hour delivery orders placed now process from 9:30am next business day.';
    return {
      service: 'Brisbane 2-hour delivery',
      availableTitle: 'Brisbane 2-hour delivery available!',
      rateLineLabel: 'Brisbane 2-hour delivery',
      cutoffText,
      detailText: cutoffText
    };
  }

  function haversine(lat1, lng1, lat2, lng2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a = Math.sin(dLat/2)**2 + Math.cos(lat1*Math.PI/180) * Math.cos(lat2*Math.PI/180) * Math.sin(dLng/2)**2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  }

  async function fetchStock(variantId) {
    if (window.__NBN_MOCK_STOCK && window.__NBN_MOCK_STOCK[variantId]) {
      return window.__NBN_MOCK_STOCK[variantId];
    }
    try {
      const res = await fetch(`${STOCK_ENDPOINT}?variant_id=${encodeURIComponent(variantId)}&_=${Date.now()}`, {
        cache: 'no-store'
      });
      const data = await res.json();
      // Untracked inventory (free gifts, consumables) — show as in stock everywhere
      if (data.untracked) return '__untracked__';
      return data.stock || {};
    } catch(e) { return null; }
  }

  function buildStockMap(stockObj) {
    const map = {};
    Object.keys(STORES).forEach(id => { map[id] = 0; });
    if (!stockObj) return map;
    Object.keys(STORES).forEach(id => {
      if (stockObj[id] !== undefined) map[id] = stockObj[id];
    });
    return map;
  }

  function stockDot(qty) {
    if (qty > 0) return `<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:#4CAF50;margin-right:6px;vertical-align:middle;"></span>`;
    return `<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:#F44336;margin-right:6px;vertical-align:middle;"></span>`;
  }

  function stockLabel(qty) {
    if (qty > 0) return 'In Stock';
    return 'Out of Stock';
  }

  function getDeliveryLabel(store) {
    return store?.deliveryLabel || '2-Hour Delivery';
  }

  function getDeliveryCutoffText(store) {
    return deliveryMetaForStore(store).detailText;
  }

  function summaryBadge(label, tone) {
    const isError = tone === 'error';
    return `<span style="display:inline-flex;align-items:center;gap:5px;padding:5px 10px;background:${isError ? '#FFF3F3' : '#E8F5E9'};border:1px solid ${isError ? '#FFCDD2' : '#A5D6A7'};border-radius:20px;font-size:12px;font-weight:600;color:${isError ? '#C62828' : '#2E7D32'};">${label}</span>`;
  }

  function deliveryBadgeLabelForStore(store) {
    if (!store) return '⚡ Fast delivery options available';
    if (store.name === 'Sydney Warehouse') return '⚡ 3 hr delivery';
    if (store.name === 'Gold Coast Warehouse') return '⚡ Same day delivery';
    return '⚡ 2 hr delivery';
  }

  function stockedLocationsForSummary() {
    return Object.entries(currentStockData)
      .filter(([id, qty]) => STORES[id] && qty > 0)
      .map(([id, qty]) => ({ id, ...STORES[id], qty }));
  }

  function selectedDeliveryStore(postcode) {
    const stockedLocations = stockedLocationsForSummary();
    if (!stockedLocations.length) return null;
    const clean = cleanPostcode(postcode);
    const pc = POSTCODES[parseInt(clean, 10)] || resolvedPostcodeCoords[clean];
    if (!pc) return null;
    return stockedLocations
      .map(store => ({ ...store, dist: haversine(pc.lat, pc.lng, store.lat, store.lng) }))
      .filter(store => store.dist <= 60)
      .sort((a, b) => a.dist - b.dist)[0] || null;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    }[char]));
  }

  function getProductTitle() {
    const candidates = [
      document.querySelector('meta[property="og:title"]')?.content,
      document.querySelector('meta[name="twitter:title"]')?.content,
      document.querySelector('h1.product-title, h1.product__title, .product-title h1, .product__title h1')?.textContent,
      document.querySelector('h1')?.textContent,
      document.title
    ];
    const title = candidates
      .map(value => String(value || '').replace(/\s*[–|-]\s*Naughty But Nice\s*$/i, '').trim())
      .find(value => value && !/^search:\s*\d+\s+results?\s+found\s+for/i.test(value));
    return title || 'Product';
  }

  function getVariantLabel() {
    const selected = document.querySelector('select[name="id"] option:checked')?.textContent;
    return selected ? selected.trim() : 'Selected variant';
  }

  function getAvailableReserveStores() {
    return Object.entries(STORES)
      .map(([id, store]) => ({ id, ...store, qty: currentStockData[id] || 0 }))
      .filter(store => store.supportsPickup !== false)
      .filter(store => store.supportsReserve !== false)
      .filter(store => currentStockData.__untracked__ || store.qty > 0);
  }

  function hasTransferSourceStock() {
    return currentStockData.__untracked__ || Object.entries(currentStockData)
      .some(([id, qty]) => STORES[id] && Number(qty) > 0);
  }

  function updateReserveStoreOptions() {
    const select = document.getElementById('nbn-reserve-store');
    if (!select) return;
    const stores = getAvailableReserveStores();
    select.innerHTML = '';
    if (!stores.length) {
      select.appendChild(new Option('No stores currently have stock', ''));
      select.disabled = true;
      return;
    }
    select.disabled = false;
    const placeholder = new Option('Choose your pickup store...', '');
    placeholder.disabled = true;
    placeholder.selected = true;
    select.appendChild(placeholder);
    stores.forEach(store => {
      const label = store.name + (currentStockData.__untracked__ ? '' : ' - ' + store.qty + ' available');
      select.appendChild(new Option(label, store.id));
    });
  }

  function toggleReservePanel() {
    const panel = document.getElementById('nbn-reserve-panel');
    const arrow = document.getElementById('nbn-reserve-arrow');
    if (!panel) return;
    const isOpen = panel.style.display !== 'none';
    panel.style.display = isOpen ? 'none' : 'block';
    if (arrow) arrow.textContent = isOpen ? '+' : '-';
  }

  async function submitReserveForm(event) {
    event.preventDefault();
    const form = document.getElementById('nbn-reserve-form');
    const result = document.getElementById('nbn-reserve-result');
    const button = document.getElementById('nbn-reserve-submit');
    const variantId = getVariantId();
    const storeId = form?.querySelector('[name="store"]')?.value || '';
    if (!variantId || !storeId) {
      if (result) result.innerHTML = '<span style="color:#C62828;">Choose an in-stock store first.</span>';
      return;
    }
    const customerName = form?.querySelector('[name="customer_name"]')?.value.trim() || '';
    if (!customerName) {
      if (result) result.innerHTML = '<span style="color:#C62828;">Enter your first name so staff know who the reserve is for.</span>';
      return;
    }

    const payload = {
      variant_id: variantId,
      variant_title: getVariantLabel(),
      product_title: getProductTitle(),
      product_url: window.location.href.split('?')[0],
      store_id: storeId,
      customer_name: customerName,
      contact: form?.querySelector('[name="contact"]')?.value.trim() || '',
      note: form?.querySelector('[name="note"]')?.value.trim() || ''
    };

    if (button) {
      button.disabled = true;
      button.textContent = 'Reserving...';
    }
    if (result) result.innerHTML = '<span style="color:#777;">Creating your store reserve...</span>';

    try {
      const res = await fetch('https://carrier.naughtybutnice.au/reserve-in-store', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (!res.ok || !data.ok) throw new Error(data.error || 'Reserve request failed');
      form.querySelectorAll('input').forEach(input => { input.value = ''; });
      updateReserveStoreOptions();
      if (result) {
        result.innerHTML = '<div style="padding:10px 12px;background:#E8F5E9;border:1px solid #A5D6A7;border-radius:6px;color:#2E7D32;line-height:1.45;"><strong>Reserved.</strong><br>We will hold this at ' + escapeHtml(data.reserve.store) + ' until close of the next business day. Please pay in store when you pick it up.</div>';
      }
    } catch (e) {
      if (result) result.innerHTML = '<span style="color:#C62828;">' + escapeHtml(e.message || 'Reserve request failed') + '</span>';
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = 'Submit Reserve Request';
      }
    }
  }

  function bindReserveEvents() {
    const toggle = document.getElementById('nbn-reserve-toggle');
    const submit = document.getElementById('nbn-reserve-submit');
    if (toggle) toggle.addEventListener('click', toggleReservePanel);
    if (submit) submit.addEventListener('click', submitReserveForm);
    updateReserveStoreOptions();
  }

  function renderStoreRows(postcode) {
    const pc = POSTCODES[parseInt(postcode)];
    let entries = Object.entries(STORES).map(([id, s]) => ({
      id, ...s, qty: currentStockData[id] || 0
    }));
    if (pc) {
      entries.forEach(e => e.dist = haversine(pc.lat, pc.lng, e.lat, e.lng));
      entries.sort((a,b) => a.dist - b.dist);
    }
    return entries.map(s => {
      const hideAddress = s.name === 'Gold Coast Warehouse';
      const mapsUrl = `https://maps.google.com/?q=${encodeURIComponent('Naughty But Nice ' + s.name + ', ' + s.address)}`;
      const panelId = `nbn-panel-${s.id}`;
      const hoursRows = s.hours.map(([day, hrs]) =>
        `<div style="display:flex;justify-content:space-between;padding:2px 0;font-size:12px;color:#444;">
          <span style="min-width:100px;color:#666;">${day}</span><span>${hrs}</span>
        </div>`
      ).join('');
      const distLabel = pc && s.dist !== undefined ? ` &middot; ${Math.max(s.dist, 0.1).toFixed(1)} km away` : '';
      const stockBadge = s.qty > 0
        ? `<span style="color:#2E7D32;font-size:12px;font-weight:600;">${stockDot(s.qty)}In Stock</span>`
        : `<span style="color:#C62828;font-size:12px;font-weight:600;">${stockDot(s.qty)}Out of Stock</span>`;
      const deliveryLabel = s.deliveryLabel || '2-Hour Delivery';
      const availableText = s.supportsPickup === false
        ? `<div style="font-size:11px;color:#4CAF50;margin-bottom:8px;">✓ ${deliveryLabel} available from this warehouse</div>`
        : `<div style="font-size:11px;color:#4CAF50;margin-bottom:8px;">✓ Click &amp; Collect &middot; ${deliveryLabel} available</div>`;
      const transferText = hasTransferSourceStock()
        ? `<div style="font-size:11px;color:#777;margin-bottom:8px;">Store Transfer for Pickup can be arranged at checkout when another location has stock.</div>`
        : '';
      const unavailableText = s.name === 'Gold Coast Warehouse'
        ? ''
        : s.supportsPickup === false
          ? `<div style="font-size:11px;color:#888;margin-bottom:8px;">Delivery currently unavailable from this warehouse</div>`
          : transferText || `<div style="font-size:11px;color:#888;margin-bottom:8px;">Contact store to order or arrange transfer</div>`;
      const actionLink = s.supportsPickup === false
        ? ''
        : `<a href="${mapsUrl}" target="_blank" rel="noopener" style="display:inline-block;padding:7px 14px;background:${CHARCOAL};color:#fff;font-size:12px;font-weight:700;border-radius:5px;text-decoration:none;">Get Directions</a>`;
      return `
      <div style="border-bottom:1px solid #F0F0F0;">
        <!-- Compact store row -->
        <div style="display:flex;align-items:center;justify-content:space-between;padding:9px 0;cursor:pointer;" onclick="(function(){var p=document.getElementById('${panelId}');var a=document.getElementById('${panelId}-arrow');p.style.display=p.style.display==='none'?'block':'none';a.textContent=p.style.display==='none'?'\u25be':'\u25b4';})()">
          <div style="display:flex;align-items:center;gap:6px;">
            <span style="font-size:13px;font-weight:600;color:${PINK};">${s.name}</span>
            <span id="${panelId}-arrow" style="font-size:10px;color:#999;">&#9662;</span>
            <span style="font-size:11px;color:#999;">${distLabel}</span>
          </div>
          <div style="display:flex;align-items:center;">${stockBadge}</div>
        </div>
        <!-- Expandable panel -->
        <div id="${panelId}" style="display:none;padding:8px 0 14px;border-top:1px solid #F4F4F4;">
          ${hideAddress ? '' : `<div style="font-size:12px;color:#666;margin-bottom:6px;">${s.address}</div>`}
          ${s.qty > 0 ? availableText : unavailableText}
          <a href="tel:${s.phone.replace(/\s/g,'')}" style="font-size:12px;font-weight:600;color:${CHARCOAL};text-decoration:none;display:inline-block;margin-bottom:10px;">📞 ${s.phone}</a>
          <div style="margin-bottom:4px;">${hoursRows}</div>
          <div style="font-size:11px;color:#888;margin:6px 0 10px;line-height:1.5;">${s.hoursNote}</div>
          ${actionLink}
        </div>
      </div>`;
    }).join('');
  }

  function renderReserveMarkup() {
    return `
        <div style="margin-top:8px;">
          <button
            id="nbn-reserve-toggle"
            type="button"
            style="width:100%;height:42px;background:#fff;color:#ED037C;border:1px solid #ED037C;border-radius:6px;font-size:13px;font-weight:700;cursor:pointer;font-family:inherit;display:flex;align-items:center;justify-content:center;gap:8px;"
          >
            <span>Reserve in Store</span><span id="nbn-reserve-arrow">+</span>
          </button>
          <div id="nbn-reserve-panel" style="display:none;margin-top:10px;padding:12px;border:1px solid #F6C2DA;background:#FFF7FB;border-radius:6px;">
            <div style="font-size:12px;line-height:1.45;color:#555;margin-bottom:10px;">No payment now. We hold the item until close of the next business day. Pay cash or card in store when you pick it up.</div>
            <div id="nbn-reserve-form">
              <label for="nbn-reserve-store" style="display:block;font-size:12px;font-weight:800;color:#171717;margin-bottom:3px;text-transform:uppercase;letter-spacing:.02em;">Choose pickup store</label>
              <div style="font-size:12px;line-height:1.35;color:#555;margin-bottom:6px;">Tap the store box below, then choose where you want us to hold it.</div>
              <div style="position:relative;margin-bottom:8px;">
                <select id="nbn-reserve-store" name="store" data-nbn-reserve-required="store" style="width:100%;height:44px;padding:0 42px 0 12px;border:2px solid #ED037C;border-radius:6px;background:#fff;color:#171717;font-size:14px;font-weight:700;font-family:inherit;appearance:none;-webkit-appearance:none;cursor:pointer;box-shadow:0 0 0 3px rgba(237,3,124,.08);"></select>
                <span aria-hidden="true" style="position:absolute;right:13px;top:50%;transform:translateY(-50%);color:#ED037C;font-size:16px;font-weight:800;pointer-events:none;">⌄</span>
              </div>
              <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:8px;">
                <input name="customer_name" data-nbn-reserve-required="customer_name" placeholder="First name" style="min-width:0;padding:9px 10px;border:1px solid #DDD;border-radius:5px;font-size:13px;font-family:inherit;">
                <input name="contact" placeholder="Mobile or email (optional)" style="min-width:0;padding:9px 10px;border:1px solid #DDD;border-radius:5px;font-size:13px;font-family:inherit;">
              </div>
              <input name="note" placeholder="Optional note" style="width:100%;box-sizing:border-box;padding:9px 10px;border:1px solid #DDD;border-radius:5px;font-size:13px;font-family:inherit;margin-bottom:8px;">
              <button id="nbn-reserve-submit" type="button" style="width:100%;padding:10px 12px;background:#171717;color:#fff;border:0;border-radius:5px;font-size:12px;font-weight:700;cursor:pointer;font-family:inherit;">Submit Reserve Request</button>
            </div>
            <div id="nbn-reserve-result" style="margin-top:9px;font-size:12px;line-height:1.45;"></div>
          </div>
        </div>`;
  }

  function render() {
    const container = document.getElementById('nbn-widget-container');
    if (!container) return;
    const reserveContainer = document.getElementById('nbn-reserve-container');

    const storedPostcode = getSharedPostcode();
    container.innerHTML = `
      <div style="
        border:1px solid #E8E8E8;
        border-radius:8px;
        background:#fff;
        font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;
        overflow:hidden;
      ">
        ${reserveContainer ? '' : renderReserveMarkup()}

        <!-- Summary badges -->
        <div id="nbn-summary-badges" style="padding:8px 12px 0;display:flex;gap:6px;flex-wrap:nowrap;overflow-x:auto;-webkit-overflow-scrolling:touch;"></div>

        <button
          id="nbn-widget-toggle"
          type="button"
          aria-expanded="false"
          aria-controls="nbn-widget-panel"
          style="
            width:100%;display:flex;align-items:center;justify-content:space-between;gap:12px;
            margin:8px 0 0;padding:12px 16px;background:#fff;border:0;border-top:1px solid #F0F0F0;
            color:${CHARCOAL};font-family:inherit;text-align:left;cursor:pointer;
          "
        >
          <span style="display:flex;align-items:center;gap:10px;min-width:0;">
            <span style="display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:999px;background:#FFF8E1;border:1px solid #FFE082;color:#8A5A00;font-size:16px;flex:0 0 auto;">⚡</span>
            <span style="display:block;min-width:0;">
              <span style="display:block;font-size:13px;font-weight:800;text-transform:uppercase;letter-spacing:0.6px;line-height:1.2;">Fast local delivery</span>
              <span style="display:block;margin-top:3px;font-size:12px;font-weight:500;color:#666;line-height:1.35;">Check fast delivery in Brisbane, Gold Coast &amp; Sydney.</span>
            </span>
          </span>
          <span id="nbn-widget-toggle-icon" aria-hidden="true" style="font-size:18px;color:${PINK};font-weight:800;line-height:1;flex:0 0 auto;">+</span>
        </button>

        <div id="nbn-widget-panel" style="display:none;">
          <!-- Stock section -->
          <div style="padding:10px 16px 0;border-top:1px solid #F7F7F7;">
            <div style="font-size:12px;font-weight:700;color:${CHARCOAL};text-transform:uppercase;letter-spacing:0.6px;margin-bottom:2px;">Store &amp; Warehouse Availability <span style="font-size:11px;font-weight:400;color:#999;text-transform:none;letter-spacing:0;">(tap location for details)</span></div>
            <div id="nbn-stock-rows">
              <div style="font-size:13px;color:#999;padding:8px 0;">Loading stock…</div>
            </div>
          </div>

          <!-- Postcode checker -->
          <div style="padding:12px 16px;border-top:1px solid #F0F0F0;margin-top:2px;">
            <div style="font-size:12px;font-weight:700;color:${CHARCOAL};text-transform:uppercase;letter-spacing:0.6px;margin-bottom:3px;">Check Local Delivery Rates</div>
            <div style="font-size:12px;color:#666;line-height:1.35;margin-bottom:8px;">Enter your postcode to see local courier options, nearby stock, or standard discreet shipping Australia-wide.</div>
            <div style="display:flex;gap:8px;position:relative;overflow:visible;">
              <div style="flex:0 0 82px;position:relative;">
                <input
                  id="nbn-pc-input"
                  type="text"
                  autocomplete="off"
                  placeholder="Postcode"
                  value="${storedPostcode}"
                  style="
                    width:100%;padding:0 10px;height:42px;
                    border:1px solid #D8D8D8;border-radius:6px;
                    font-size:15px;font-family:inherit;text-align:center;
                    outline:none;box-sizing:border-box;
                  "
                />
              </div>
              <button
                id="nbn-pc-btn"
                type="button"
                style="
                  flex:1 1 auto;min-width:0;padding:0 14px;height:42px;
                  background:${PINK};color:#fff;border:none;
                  border-radius:6px;font-weight:700;font-size:13px;
                  cursor:pointer;transition:background 0.2s;white-space:nowrap;
                "
                onmouseover="this.style.background='#CA036A'"
                onmouseout="this.style.background='${PINK}'"
              >${storedPostcode ? 'Update' : 'Check'}</button>
              <button
                id="nbn-pc-clear-btn"
                type="button"
                title="Clear postcode"
                aria-label="Clear postcode"
                style="
                  display:${storedPostcode ? 'inline-flex' : 'none'};
                  align-items:center;justify-content:center;
                  flex:0 0 42px;min-width:42px;padding:0;height:42px;
                  background:#fff;color:${CHARCOAL};border:1px solid #D8D8D8;
                  border-radius:6px;font-weight:800;font-size:20px;line-height:1;
                  cursor:pointer;transition:background 0.2s;white-space:nowrap;
                "
                onmouseover="this.style.background='#F7F7F7'"
                onmouseout="this.style.background='#fff'"
              >&times;</button>
            </div>
            <div id="nbn-pc-result" style="margin-top:8px;font-size:13px;"></div>
          </div>

        <!-- Shipping rates (collapsible) -->
        <div style="border-top:1px solid #F0F0F0;background:#FAFAFA;">
          <div style="display:flex;align-items:center;justify-content:space-between;padding:10px 16px;cursor:pointer;border-radius:6px;transition:background 0.15s;" onmouseover="this.style.background='#F0F0F0'" onmouseout="this.style.background='transparent'" onclick="(function(){var p=document.getElementById('nbn-shipping-panel');var a=document.getElementById('nbn-shipping-arrow');p.style.display=p.style.display==='none'?'block':'none';a.textContent=p.style.display==='none'?'\u25be':'\u25b4';})()">
            <div style="display:flex;align-items:center;gap:6px;">
              <span style="font-size:12px;font-weight:700;color:${CHARCOAL};text-transform:uppercase;letter-spacing:0.6px;">Shipping Rates (Australia)</span>
              <span style="font-size:11px;color:#999;font-weight:400;text-transform:none;letter-spacing:0;">— tap to view rates</span>
            </div>
            <span id="nbn-shipping-arrow" style="font-size:13px;color:${PINK};font-weight:700;">&#9662;</span>
          </div>
          <div id="nbn-shipping-panel" style="display:none;padding:0 16px 12px;">
            <div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #F0F0F0;font-size:13px;">
              <span style="color:#444;">Aus Post Standard (2–8 days)</span><span style="font-weight:600;color:${CHARCOAL};">$10</span>
            </div>
            <div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #F0F0F0;font-size:13px;">
              <span style="color:#444;">Aus Post Express (1–4 days)</span><span style="font-weight:600;color:${CHARCOAL};">$15</span>
            </div>
            <div style="display:flex;justify-content:space-between;padding:6px 0;font-size:13px;">
              <span style="color:#444;">Express (orders $150+)</span><span style="font-weight:700;color:${PINK};">FREE</span>
            </div>
          </div>
        </div>
        </div>
      </div>
    `;
    if (reserveContainer) reserveContainer.innerHTML = renderReserveMarkup();

    // Attach events
    const toggle = document.getElementById('nbn-widget-toggle');
    const panel = document.getElementById('nbn-widget-panel');
    const toggleIcon = document.getElementById('nbn-widget-toggle-icon');
    if (toggle && panel) {
      toggle.addEventListener('click', () => {
        const isOpen = panel.style.display !== 'none';
        panel.style.display = isOpen ? 'none' : 'block';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        if (toggleIcon) toggleIcon.textContent = isOpen ? '+' : '-';
      });
    }
    document.getElementById('nbn-pc-btn').addEventListener('click', checkPostcode);
    document.getElementById('nbn-pc-clear-btn').addEventListener('click', () => clearSharedPostcode('product-widget'));
    document.getElementById('nbn-pc-input').addEventListener('keypress', e => { if(e.key==='Enter') { hideSuggestions(); checkPostcode(); } });
    document.getElementById('nbn-pc-input').addEventListener('input', e => {
      const raw = e.target.value;
      updatePostcodeButtonState();
      // If purely numeric, leave as-is (postcode)
      if (/^\d+$/.test(raw)) {
        showSuggestions(raw);
        return;
      }
      showSuggestions(raw);
    });
    document.getElementById('nbn-pc-input').addEventListener('blur', () => {
      setTimeout(hideSuggestions, 150);
    });
    bindReserveEvents();

    // Create dropdown on body so it can't be clipped by any parent overflow:hidden
    let _suggestEl = null;
    function getSuggestBox() {
      if (!_suggestEl) {
        _suggestEl = document.createElement('div');
        _suggestEl.id = 'nbn-pc-suggestions';
        _suggestEl.style.cssText = 'display:none;position:fixed;background:#fff;border:1px solid #D8D8D8;border-radius:6px;box-shadow:0 8px 24px rgba(0,0,0,0.2);z-index:2147483647;max-height:220px;overflow-y:auto;';
        document.body.appendChild(_suggestEl);
      }
      return _suggestEl;
    }

    function positionSuggestBox() {
      const input = document.getElementById('nbn-pc-input');
      if (!input) return;
      const rect = input.getBoundingClientRect();
      const box = getSuggestBox();
      box.style.top = (rect.bottom + 4) + 'px';
      box.style.left = rect.left + 'px';
      box.style.width = rect.width + 'px';
    }

    let _suggestTimer = null;
    function showSuggestions(query) {
      if (!query || query.length < 2) { hideSuggestions(); return; }
      clearTimeout(_suggestTimer);
      _suggestTimer = setTimeout(async () => {
        try {
          const endpoint = STOCK_ENDPOINT.replace('/stock', '/suburbs');
          const res = await fetch(`${endpoint}?q=${encodeURIComponent(query)}`);
          const matches = await res.json();
          const box = getSuggestBox();
          if (!matches.length) { hideSuggestions(); return; }
          box.innerHTML = matches.map(m =>
            `<div data-pc="${m.pc}" style="
              padding:10px 14px;cursor:pointer;font-size:14px;color:#252525;
              display:flex;justify-content:space-between;align-items:center;
              border-bottom:1px solid #F5F5F5;
            " onmouseover="this.style.background='#FFF0F7'" onmouseout="this.style.background='#fff'">
              <span>${m.suburb} <span style="font-size:12px;color:#aaa;">${m.state}</span></span>
              <span style="font-size:12px;color:#999;">${m.pc}</span>
            </div>`
          ).join('');
          box.querySelectorAll('[data-pc]').forEach(el => {
            el.addEventListener('mousedown', () => {
              const pc = el.getAttribute('data-pc');
              document.getElementById('nbn-pc-input').value = pc;
              hideSuggestions();
              checkPostcode();
            });
          });
          positionSuggestBox();
          box.style.display = 'block';
        } catch(e) { hideSuggestions(); }
      }, 200);
    }

    function hideSuggestions() {
      if (_suggestEl) _suggestEl.style.display = 'none';
    }

    // Reposition on scroll/resize so it tracks the input
    window.addEventListener('scroll', positionSuggestBox, true);
    window.addEventListener('resize', positionSuggestBox);

    loadStock();
    watchVariants();
    updatePostcodeButtonState();
    if (storedPostcode) window.setTimeout(() => checkPostcode({ actual: hasActualSharedPostcode(), source: 'product-widget-auto' }), 0);
  }

  function updatePostcodeButtonState() {
    const button = document.getElementById('nbn-pc-btn');
    const clear = document.getElementById('nbn-pc-clear-btn');
    const input = document.getElementById('nbn-pc-input');
    if (!button) return;
    const hasKnownPostcode = !!getSharedPostcode() || !!cleanPostcode(input && input.value);
    button.textContent = hasKnownPostcode ? 'Update' : 'Check';
    if (clear) clear.style.display = getSharedPostcode() ? 'inline-flex' : 'none';
  }

  window.addEventListener('nbn:postcode-updated', event => {
    const postcode = cleanPostcode(event.detail?.postcode);
    if (!postcode) {
      if (event.detail?.source !== 'product-widget') {
        const input = document.getElementById('nbn-pc-input');
        const result = document.getElementById('nbn-pc-result');
        if (input) input.value = '';
        if (result) result.innerHTML = '';
        refreshStoreRows('');
        updatePostcodeButtonState();
      }
      return;
    }
    if (event.detail?.source === 'product-widget') return;
    const input = document.getElementById('nbn-pc-input');
    if (input && input.value !== postcode) input.value = postcode;
    setSharedPostcode(postcode, event.detail?.source || 'external-widget', { actual: event.detail?.actualPostcode !== false });
    updatePostcodeButtonState();
    if (document.getElementById('nbn-pc-result')) {
      window.setTimeout(() => checkPostcode({ actual: hasActualSharedPostcode(), source: 'product-widget-auto' }), 0);
    }
  });
  window.addEventListener('nbn:postcode-cleared', event => {
    if (event.detail?.source === 'product-widget') return;
    const input = document.getElementById('nbn-pc-input');
    const result = document.getElementById('nbn-pc-result');
    if (input) input.value = '';
    if (result) result.innerHTML = '';
    refreshStoreRows('');
    updatePostcodeButtonState();
  });

  async function resolvePostcode(val) {
    // Try static map first
    const pc = POSTCODES[parseInt(val)];
    if (pc) return pc;
    // Fallback: server-side geocode (avoids CORS issues)
    try {
      const r = await fetch(`${STOCK_ENDPOINT.replace('/stock', '/geocode')}?postcode=${val}`);
      const data = await r.json();
      if (data && data.lat) return { lat: data.lat, lng: data.lng };
    } catch(e) {}
    return null;
  }

  async function checkPostcode(options = {}) {
    const actualPostcode = options.actual !== false;
    const source = options.source || 'product-widget';
    const raw = document.getElementById('nbn-pc-input').value.trim();
    const result = document.getElementById('nbn-pc-result');
    updatePostcodeButtonState();
    // Resolve suburb name to postcode if needed
    let val = raw;
    if (!/^\d{4}$/.test(raw)) {
      const match = SUBURB_MAP.find(s => s.suburb.toLowerCase() === raw.toLowerCase());
      if (match) {
        val = String(match.pc);
        document.getElementById('nbn-pc-input').value = val;
      } else {
        result.innerHTML = `<span style="color:#999;">Please enter a suburb name or 4-digit postcode.</span>`;
        return;
      }
    }
    setSharedPostcode(val, source, { actual: actualPostcode });
    updatePostcodeButtonState();
    result.innerHTML = `<span style="color:#999;">Checking...</span>`;
    const pc = await resolvePostcode(val);
    if (!pc) {
      result.innerHTML = `<span style="color:#999;">Local delivery is not available for this area.</span>`;
      refreshStoreRows(val);
      return;
    }
    resolvedPostcodeCoords[val] = pc;
    // Find nearest store within 50km that has stock
    const nearby = Object.entries(STORES).map(([id,s]) => ({
      ...s, id, dist: haversine(pc.lat, pc.lng, s.lat, s.lng), qty: currentStockData[id] || 0
    })).filter(s => s.dist <= 60 && s.qty > 0).sort((a,b)=>a.dist-b.dist);

    // Tiered local delivery rate based on distance to nearest stocked location.
    function get2hrRate(distKm) {
      if (distKm <= 10) return '$19.95';
      if (distKm <= 15) return '$24.95';
      if (distKm <= 20) return '$29.95';
      if (distKm <= 25) return '$34.95';
      if (distKm <= 30) return '$39.95';
      if (distKm <= 35) return '$44.95';
      if (distKm <= 40) return '$49.95';
      if (distKm <= 45) return '$59.95';
      if (distKm <= 50) return '$69.95';
      if (distKm <= 55) return '$79.95';
      if (distKm <= 60) return '$89.95';
      return null;
    }
    function rateToCents(rate) {
      return Math.round(Number(String(rate || '').replace(/[^0-9.]/g, '')) * 100);
    }

    if (nearby.length > 0) {
      const store = nearby[0];
      const rate = get2hrRate(store.dist);
      const nearbyRateLabels = nearby
        .map(s => get2hrRate(s.dist))
        .filter(Boolean)
        .sort((a, b) => rateToCents(a) - rateToCents(b));
      const minRate = nearbyRateLabels[0] || rate;
      const maxRate = nearbyRateLabels[nearbyRateLabels.length - 1] || rate;
      const rangeRate = minRate && maxRate && minRate !== maxRate ? `${minRate}-${maxRate}` : rate;
      const meta = deliveryMetaForStore(store);
      const deliveryLabel = meta.service || getDeliveryLabel(store);
      const cutoffText = meta.detailText;
      const detailHtml = meta.detailHtml || `<div style="font-size:12px;color:#4b4b4b;margin-top:6px;line-height:1.45;">${cutoffText}</div>`;
      const estimateLine = meta.service === 'Brisbane 2-hour delivery' && rangeRate !== rate
        ? (hasActualSharedPostcode()
          ? `<strong>Estimated for ${val}: ${rangeRate}</strong> depending on the stocked store.`
          : `<strong>Starting from $19.95</strong> once your postcode is confirmed.`)
        : (hasActualSharedPostcode()
          ? `<strong>Estimated for ${val}: ${rate}</strong> based on your postcode.`
          : `<strong>Starting from $19.95</strong> once your postcode is confirmed.`);
      const isWithinFreeZone = store.dist <= 20;
      const freePromo = isWithinFreeZone
        ? `<div style="margin-top:8px;padding:7px 10px;background:#FFF8E1;border:1px solid #FFE082;border-radius:5px;font-size:12px;color:#795548;">🎉 <strong>Spend $250+ and get FREE ${deliveryLabel}</strong> to your door!</div>`
        : `<div style="margin-top:8px;padding:7px 10px;background:#FFF8E1;border:1px solid #FFE082;border-radius:5px;font-size:12px;color:#795548;">💡 Free local delivery on orders $250+ within 20km of our stores and warehouses.</div>`;
      result.innerHTML = `
        <div style="margin-top:4px;padding:12px 14px;background:#F0FBF0;border:1px solid #C8E6C9;border-radius:6px;">
          <div style="font-size:13px;font-weight:700;color:#2E7D32;margin-bottom:6px;">✓ ${meta.availableTitle}</div>
          <div style="font-size:13px;color:#444;margin-bottom:8px;">Nearest stocked location: <strong>${store.name}</strong> &mdash; ${Math.max(store.dist, 0.1).toFixed(1)} km away</div>
          <div style="border-top:1px solid #C8E6C9;padding-top:8px;">
            <div style="display:flex;justify-content:space-between;font-size:13px;padding:3px 0;">
              <span style="color:#444;">${meta.rateLineLabel}</span>
              <span style="font-weight:700;color:${CHARCOAL};">${rate}</span>
            </div>
            <div style="font-size:12px;color:#4b4b4b;margin-top:3px;line-height:1.45;">${estimateLine}</div>
            ${detailHtml}
            ${freePromo}
            <div style="font-size:11px;color:#888;margin-top:6px;line-height:1.5;">
              Rate and stock confirmed at checkout.<br>
              If ordering from multiple stores, rates may combine at checkout.<br>
              For help, <a href="/pages/contact-us" style="color:${PINK};text-decoration:none;">contact us</a>.
            </div>
          </div>
        </div>
      `;
    } else {
      // Check if they're within 50km but not in nearby (shouldn't happen, just safety)
      // Check if any store has stock at all
      const hasAnyStock = Object.values(currentStockData).some(q => q > 0);
      if (!hasAnyStock) {
        result.innerHTML = `<div style="padding:10px 14px;background:#FFF3F3;border:1px solid #FFCDD2;border-radius:6px;font-size:13px;color:#C62828;">Local delivery is unavailable — this item is currently out of stock in all stores and warehouses.</div>`;
      } else {
        const eta = expressPostEta(val);
        result.innerHTML = `<div style="padding:10px 14px;background:#FFF8E1;border:1px solid #FFE082;border-radius:6px;font-size:13px;color:#6f4a00;">Local delivery is not available for postcode ${val} — no stocked store or warehouse is within our delivery zone. ${eta.detail}</div>`;
      }
    }
    refreshStoreRows(val);
  }

  function refreshStoreRows(postcode) {
    const rows = document.getElementById('nbn-stock-rows');
    if (rows) rows.innerHTML = renderStoreRows(postcode);
    updateReserveStoreOptions();
    // Update summary badges
    const badges = document.getElementById('nbn-summary-badges');
    if (!badges) return;
    const isUntracked = currentStockData.__untracked__;
    const stockedLocations = stockedLocationsForSummary();
    const hasStock = isUntracked || stockedLocations.length > 0;
    if (!hasStock) {
      badges.innerHTML = summaryBadge('Currently unavailable locally', 'error');
      return;
    }
    const clean = cleanPostcode(postcode || getSharedPostcode());
    if (!clean) {
      badges.innerHTML = summaryBadge('⚡ Fast delivery options available');
      return;
    }
    const store = selectedDeliveryStore(clean);
    if (isUntracked || store) {
      badges.innerHTML = summaryBadge(deliveryBadgeLabelForStore(store));
    } else {
      badges.innerHTML = summaryBadge('Express delivery available');
    }
  }

  async function loadStock() {
    const variantId = getVariantId();
    if (!variantId) return;
    const levels = await fetchStock(variantId);
    currentStockData = buildStockMap(levels);
    const storedPostcode = getSharedPostcode();
    const input = document.getElementById('nbn-pc-input');
    if (input && storedPostcode) input.value = storedPostcode;
    refreshStoreRows(storedPostcode);
    if (storedPostcode) window.setTimeout(() => checkPostcode({ actual: hasActualSharedPostcode(), source: 'product-widget-auto' }), 0);
  }

  function handleVariantChange(variantId) {
    if (!variantId || String(variantId) === String(lastSeenVariantId)) return;
    lastSeenVariantId = String(variantId);
    reloadStock(lastSeenVariantId);
  }

  function watchVariants() {
    lastSeenVariantId = getVariantId();

    ['variant:changed', 'variant:change', 'shopify:variant:change'].forEach(eventName => {
      document.addEventListener(eventName, e => {
        const variantId = e.detail?.variantId || e.detail?.variant?.id || getVariantId();
        handleVariantChange(variantId);
      });
    });

    document.addEventListener('change', e => {
      if (e.target?.matches?.('select[name="id"], input[name="id"], input[type="radio"]')) {
        window.setTimeout(() => handleVariantChange(getVariantId()), 0);
      }
    });

    const variantObserver = new MutationObserver(() => handleVariantChange(getVariantId()));
    const observeVariantInput = () => {
      const input = document.querySelector('input[name="id"], select[name="id"]');
      if (input) variantObserver.observe(input, { attributes: true, attributeFilter: ['value', 'disabled'] });
    };
    observeVariantInput();
    new MutationObserver(observeVariantInput).observe(document.body, { subtree: true, childList: true });

    window.setInterval(() => handleVariantChange(getVariantId()), 500);
  }

  function watchUrlVariantChanges() {
    if (window.__NBN_WIDGET_URL_WATCHER__) return;
    window.__NBN_WIDGET_URL_WATCHER__ = true;
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    const notify = () => window.setTimeout(() => handleVariantChange(getVariantId()), 0);

    history.pushState = function() {
      const result = originalPushState.apply(this, arguments);
      notify();
      return result;
    };
    history.replaceState = function() {
      const result = originalReplaceState.apply(this, arguments);
      notify();
      return result;
    };
    window.addEventListener('popstate', notify);
  }

  async function reloadStock(variantId) {
    const reloadSequence = ++stockReloadSequence;
    const levels = await fetchStock(variantId);
    if (reloadSequence !== stockReloadSequence) return;
    currentStockData = buildStockMap(levels);
    const pcInput = document.getElementById('nbn-pc-input');
    const postcode = cleanPostcode(pcInput ? pcInput.value : getSharedPostcode());
    refreshStoreRows(postcode);
    if (postcode) window.setTimeout(() => checkPostcode({ actual: hasActualSharedPostcode(), source: 'product-widget-auto' }), 0);
  }

  function getVariantId() {
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) return urlVariant;
    const form = document.querySelector('form[action*="/cart/add"], product-form form, form[id^="product-form"]');
    const selectedRadio = form?.querySelector('input[type="radio"][name="id"]:checked') || document.querySelector('input[type="radio"][name="id"]:checked');
    if (selectedRadio?.value) return selectedRadio.value;
    const sel = form?.querySelector('select[name="id"]') || document.querySelector('select[name="id"]');
    if (sel?.value) return sel.value;
    const activeInput = form?.querySelector('input[name="id"]:not([disabled])') || document.querySelector('input[name="id"]:not([disabled])');
    if (activeInput?.value) return activeInput.value;
    const inp = form?.querySelector('input[name="id"]') || document.querySelector('input[name="id"]');
    if (inp?.value) return inp.value;
    const pickup = document.querySelector('pickup-availability[data-variant-id], [data-variant-id]');
    if (pickup?.dataset?.variantId) return pickup.dataset.variantId;
    return null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }

  watchUrlVariantChanges();

  new MutationObserver(() => {
    if (document.getElementById('nbn-widget-container') && !document.getElementById('nbn-stock-rows')) render();
  }).observe(document.body, { subtree:true, childList:true });

})();
